// Desk build only: when the app runs inside Route Desk's "HE Products" panel
// (an iframe of about 469 x 505 px on a 1366x768 screen), switch on a compact
// look that matches Route Desk: Poppins, Route Desk's text sizes, a light glass
// finish. All of it lives in styles/desk-panel.less, where every rule starts
// with `.he-desk-panel`. This helper only sets that class (and loads the
// font), so outside a frame - phones, or desk.heorderapp.online opened in a
// normal tab - nothing changes.

export const DESK_PANEL_CLASS = "he-desk-panel";
export const DESK_FONT_LINK_ID = "he-desk-panel-font";
export const DESK_FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap";

// True when this page is inside a frame. Same test as deskOrderingFor.js.
// A cross-origin top window can make the comparison throw in old browsers;
// that only happens inside a frame.
export const isInRouteDeskFrame = (win = window) => {
  try {
    return win.self !== win.top;
  } catch (e) {
    return true;
  }
};

// Called once at app start. Returns true when the panel look was switched on.
export const applyDeskPanelLook = (win = window, doc = win.document) => {
  if (!isInRouteDeskFrame(win)) return false;
  doc.documentElement.classList.add(DESK_PANEL_CLASS);
  if (!doc.getElementById(DESK_FONT_LINK_ID)) {
    const link = doc.createElement("link");
    link.id = DESK_FONT_LINK_ID;
    link.rel = "stylesheet";
    link.href = DESK_FONT_HREF;
    doc.head.appendChild(link);
  }
  return true;
};
